<template>
    <div class="content">
        <div class="b_img"></div>
        <ul v-for="item in dataJson" v-if="item.datas">
            <li>
                <h3 class="title">{{item.name}}</h3>
                <template v-if="item.dataType=='table'" v-for="itemdatas in item.datas">
                    <h4 class="subName" v-if="itemdatas.titleName">{{itemdatas.titleName}}</h4>
                    <!-- <table>
                            <thead>
                                <tr>
                                    <th v-for="th in itemdatas.th">{{th.tableHead}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(tdInfo,index) in itemdatas.td">
                                    <td v-for="val in tdInfo">{{val}}</td>
                                </tr>
                            </tbody>
                        </table> -->
                    <el-table :data="itemdatas.td">
                        <template v-for="(tabledata, index) in itemdatas.tabledata">
                          <el-table-column v-if="tabledata.tdName === 'image'" :prop="tabledata.tdName" :label="tabledata.tableHead" :min-width="tabledata.tableHead==='说明'?250:' '" align="center">
                            <template slot-scope="scope">
                              <el-popover
                                placement="top"
                                width="330"
                                trigger="click">
                              <el-image :src="scope.row.image"></el-image>
                              <el-image :src="scope.row.image" slot="reference" style="cursor: pointer;"></el-image>
                              </el-popover>
                            </template>
                          </el-table-column>
                            <el-table-column v-else-if="tabledata.tableHead==='说明'" :prop="tabledata.tdName" :label="tabledata.tableHead"
                                                :min-width="250" align="center">
                                <template slot-scope="scope">
                                <div v-html="getCustomShowDom(scope, tabledata)"></div>
                                </template>
                            </el-table-column>
                            <el-table-column v-else :prop="tabledata.tdName" :label="tabledata.tableHead" :min-width="tabledata.tableHead=='说明'?250:' '" align="center">
                            </el-table-column>
                        </template>
                    </el-table>
                </template>
                <div v-if="item.dataType==='text'">{{item.datas}}</div>
                <div v-if="item.dataType==='img'">
                  <el-image :src="item.datas"></el-image>
                </div>
                <div v-if="item.dataType==='code'">
                    <slot :name="item.datas">
                        只有在没有要分发的内容时才会显示。
                    </slot>
                </div>
            </li>
        </ul>
    </div>
</template>


<script>
export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            dataJson: [
                { name: "业务说明", datas: this.Pdatas.explain, dataType: "text" },
                { name: "对接流程", datas: this.Pdatas.flow, dataType: "img" },
                //{ name: "生产环境服务地址", datas: this.Pdatas.p_url, dataType: 'text' },
                { name: "sdk方式", datas: this.Pdatas.sdkcondition, dataType: 'text' },
                { name: "http接入方式下ydto访问第三方车场的地址", datas: this.Pdatas.httpcondition, dataType: 'text' },
                { name: "前置条件", datas: this.Pdatas.precondition, dataType: 'text' },
                { name: "适用系统", datas: this.Pdatas.fitSystem, dataType: "text" },
                { name: "调用方式", datas: this.Pdatas.pattern, dataType: 'text' },
                { name: "调用频度", datas: this.Pdatas.frequency, dataType: 'text' },
                { name: "请求参数说明", datas: this.Pdatas.Q_params, dataType: 'table' },
                { name: "请求参数示例", datas: 'q_code', dataType: 'code' },
                { name: "响应参数说明", datas: this.Pdatas.R_params, dataType: 'table' },
                { name: "响应参数示例", datas: 'r_code', dataType: 'code' },
                
            ],
            othersData: [],
            explainWidth: 200,
        }
    },
    methods: {
        getCustomShowDom(scope, tableData) {
        let tdData = scope.row[tableData.tdName]
        if ((!tdData) || tdData.length === 0) {
            return '<label></label>'
        }
        if (tdData.indexOf('<url>') > -1) {
            let startIndex = tdData.indexOf('<url>')
            let firstData = tdData.substring(0, startIndex)
            let endIndex = tdData.indexOf('</url>')
            let link = tdData.substring(startIndex + 5, endIndex)
            let linkArr = link.split(':')
            let lastData = tdData.substring(endIndex + 6)
            return  '<span>' + firstData + '</span>' +
                    '<a class="el-link el-link--primary" type="primary" href="' + linkArr[1] + '">' + linkArr[0] + '</a>' +
                    '<span>' + lastData + '</span>'
        }
        return tdData
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    h3 {
        font-size: 16px;
        margin: 20px 0 10px 0;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}
</style>



// WEBPACK FOOTER //
// src/components/comUpwardStructureForThirdPark.vue